export class Log {
    private _logger: string;
    private _level: string;
    private _message: string;
    private _date: Date;

    constructor(logger, level, message, date) {
        this._logger = logger;
        this._level = level;
        this._message = message;
        this._date = date;
    }
    public logger(): string {
        return this._logger;
    }
    public level(): string {
        return this._level;
    }
    public message() {
        return this._message;
    }
    public date(): Date {
        return this._date;
    }

}